export const TICKETING = 'ticketing'
export const LIVE_STREAMING = 'liveStreaming'
export const EVENT = 'event'
export const PRODUCT = 'product'
export const NFT = 'nft'
export const PACKAGE = 'package'
